import CareOptionsCarousel from "./Carousel";
import CareOptionsList from "./List";

export default (props) => (
  <div>
    <div className="standby-info-card-view">
      {props.viewMode === "carousel" ? (
        <CareOptionsCarousel {...props} />
      ) : (
        <CareOptionsList {...props} />
      )}
    </div>

    <div className="standby-info-card-view-mobile">
      {props.viewMode === "list" ? (
        <CareOptionsCarousel {...props} />
      ) : (
        <CareOptionsList {...props} />
      )}
    </div>
  </div>
);
